import { enumToOptions } from '@libs/types/src/common/enum/util';

export enum EPrescriptionMagistraliterIngredientTypeEnum {
    RAW_MATERIAL = 'RAW_MATERIAL',
    REGISTERED_MEDICATION = 'REGISTERED_MEDICATION',
    CANNABIS = 'CANNABIS',
}

export const ePrescriptionMagistraliterIngredientTypeEnumOptions = enumToOptions(
    EPrescriptionMagistraliterIngredientTypeEnum,
    'ePrescriptions.magistraliterIngredientTypeEnum.',
);

export const E_PRESCRIPTION_CANNABIS_SUBSTANCES = [
    {
        name: 'ePrescriptions.cannabisSubstance.9190000',
        ingredientName: 'Konopí pro léčebné použití',
        value: '9190000',
    },
    {
        name: 'ePrescriptions.cannabisSubstance.9390000',
        ingredientName: 'Extrakt z konopí pro léčebné použití',
        value: '9390000',
    },
] as const;

export const E_PRESCRIPTION_CANNABIS_SUBSTANCE_CODES = E_PRESCRIPTION_CANNABIS_SUBSTANCES
    .map(substance => substance.value);

export function isEPrescriptionCannabisSubstanceCode(code: string | null | undefined): boolean {
    return E_PRESCRIPTION_CANNABIS_SUBSTANCE_CODES.some(cannabisCode => cannabisCode === code);
}
